<template>
  <div class="SectionSocialProof">
    <div class="SectionSocialProof__clients">
      <ul class="SectionSocialProof__logos" role="list">
        <li
          v-for="logo in socialProofLogos"
          :key="logo.name"
          class="SectionSocialProof__logo"
        >
          <img
            :src="logo.src"
            :alt="logo.name"
            class="SectionSocialProof__logo-image"
            loading="lazy"
            :style="{
              '--logo-height': logo.height,
              '--logo-height-md': logo.heightMd,
            }"
          />
        </li>
      </ul>
    </div>

    <div class="SectionSocialProof__rating">
      <div class="SectionSocialProof__stars">★★★★★</div>
      <span class="SectionSocialProof__rating-score">4.9</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { socialProofLogos } from './socialProofLogos'
</script>

<style lang="scss" scoped>
.SectionSocialProof {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.SectionSocialProof__clients {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.SectionSocialProof__logos {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0;
  margin: 0;
  list-style: none;
  margin-right: 1.25rem;
}

.SectionSocialProof__logo {
  display: flex;
  align-items: center;
  justify-content: center;
}

.SectionSocialProof__logo-image {
  height: var(--logo-height, 1.75rem);
  width: auto;
  object-fit: contain;
  margin-right: -1.25rem;

  @include md {
    height: var(--logo-height-md, var(--logo-height, 1.75rem));
  }
}

.SectionSocialProof__rating {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.SectionSocialProof__stars {
  color: #fbbf24;
  font-size: 1.125rem;
}

.SectionSocialProof__rating-score {
  @include font-size-16px();
  color: $color-ui-gray-cool-900;
  font-weight: 600;
}
</style>
